module.exports = __webpack_public_path__ + "img/Large-Vertical-Rectangular-Attachment-41.adcdfe5f.png";